import { TypeOf } from '@guiker/shared-framework'

import { stockSchema } from './stock-schema'

export const updateStockSchema = stockSchema

export type UpdateStockSchema = TypeOf<typeof updateStockSchema>
